/**
 * Venue selector used across the Teams screens. Thin wrapper around the
 * Radix Themes Select bound to a numeric venue id.
 */
import { Select } from '@radix-ui/themes';
import type { VenueOption } from './types';

interface Props {
  venues: VenueOption[];
  value: number | null;
  onChange: (id: number) => void;
}

const VenuePicker: React.FC<Props> = ({ venues, value, onChange }) => (
  <Select.Root
    value={value !== null ? String(value) : undefined}
    onValueChange={(v) => onChange(Number(v))}
  >
    <Select.Trigger placeholder="Select venue…" aria-label="Venue" />
    <Select.Content>
      {venues.map((v) => (
        <Select.Item key={v.id} value={String(v.id)}>
          {v.name}
        </Select.Item>
      ))}
    </Select.Content>
  </Select.Root>
);

export default VenuePicker;
